module.exports = __webpack_public_path__ + "img/bbc-radio-2.4fc3f5ec.png";